import { apiRequest } from '@/Groups/Polymarket/private/imports/externalUtils';
import { INSIDER_PARAM_NAMES } from '@/Groups/Polymarket/private/constants/config';

const BASE = '/api/polymarket';

//Получить трейды с фильтрами
export const apiGetTrades = (params = {}, signal = null) => {
  const { page = 1, customUrl = null, ...filters } = params;
  
  if (customUrl) return apiRequest(customUrl, { signal });

  const searchParams = new URLSearchParams({ page });
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    searchParams.append(key, value === true ? 'True' : value);
  });
  return apiRequest(`/api/polymarket/trades/?${searchParams.toString()}`, { signal });
};

//Получить список инсайдеров
export const apiGetInsiders = ({
  page = 1, freshWallet = false, activeHold, category, insiderParams, signal = null,
} = {}) => {
  const searchParams = new URLSearchParams({ page });
  if (freshWallet) searchParams.append('fresh_wallet', 'true');
  // active_hold=true — дефолт на бэке, не шлём; false передаём явно.
  if (activeHold === false) searchParams.append('active_hold', 'false');
  // category отсылаем всегда, если определено (даже пустое): бэк отличает «не фильтруем» от «всё снято».
  if (category !== undefined && category !== null) searchParams.append('category', category);
  // Пользовательские пороги (max_unique_markets/min_max_bet/min_op_value/fresh_wallet_window_days):
  // шлём только непустые. Отсутствие = бэк берёт дефолт.
  if (insiderParams) {
    INSIDER_PARAM_NAMES.forEach((name) => {
      const val = insiderParams[name];
      if (val !== null && val !== undefined) searchParams.append(name, val);
    });
  }
  return apiRequest(`${BASE}/insiders/?${searchParams.toString()}`, { signal });
};

//Получить дефолты и допустимые границы для переопределяемых порогов инсайдер-фильтра.
export const apiGetInsiderConfig = ({ signal = null } = {}) =>
  apiRequest(`${BASE}/insiders/config/`, { signal });

//Получить следующую страницу пагинации
export const apiGetNextPage = (url, signal) =>
  apiRequest(url, { signal });

//Поиск трейдов
export const apiSearchTrades = (query) =>
  apiRequest(`${BASE}/trades/search/?q=${encodeURIComponent(query)}`);

//Получить избранные трейды
export const apiGetTradesBookmarks = () =>
  apiRequest(`${BASE}/trades/bookmark/`);

//Добавить / убрать из избранного (переиспользуем reactionsApi если нужно)
export const apiToggleTradeBookmark = (objectId, contentType) =>
  apiRequest('/api/reactions/bookmarks/create/', {
    method: 'POST',
    body: JSON.stringify({ object_id: objectId, content_type: contentType }),
  });